import { Download } from "lucide-react";
import { useTranslation } from "@/packages/utils";
import { SideSheet, Avatar } from "@/components/ui";

interface DocumentDetailFooterProps {
  onDownload: () => void;
  isDownloadLoading: boolean;
  authorName: string;
  authorEmail?: string;
  authorAvatarUrl?: string;
  authorAvatarColor?: string;
}

export function DocumentDetailFooter({
  onDownload,
  isDownloadLoading,
  authorName,
  authorEmail,
  authorAvatarUrl,
  authorAvatarColor,
}: DocumentDetailFooterProps) {
  const { t } = useTranslation("documents");
  return (
    <SideSheet.Footer>
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-4">
          {/* Author */}
          <div className="flex items-center gap-3">
            <Avatar
              name={authorName}
              avatarUrl={authorAvatarUrl}
              avatarColor={authorAvatarColor}
              size="md"
              ring
            />
            <div>
              <p className="text-[12px] text-primary font-medium">
                {authorName}
              </p>
              <p className="text-[10px] text-muted">
                {authorEmail ?? t("detail.owner")}
              </p>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onDownload}
            disabled={isDownloadLoading}
            className="flex items-center gap-2 h-8 px-3.5 rounded-lg bg-accent text-[13px] text-white font-medium hover:bg-accent/90 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Download size={14} />
            {t("detail.download")}
          </button>
        </div>
      </div>
    </SideSheet.Footer>
  );
}
